import { AuthActions } from '../actions/consts';
import { User } from '../models/';
import { setToken } from '../services/token';

export type AuthState = {
  username: string | null;
  currentUser: User;
  loading: boolean;
  errorMessage: string;
};

export function auth(state = { username: null, currentUser: null, loading: false, errorMessage: '' } as AuthState, action) {
  switch (action.type) {

    case AuthActions.VALIDATE_REQUEST:
      return {
        ...state,
        loading: true,
        errorMessage: '',
      };

    // User login
    case AuthActions.LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        errorMessage: '',
        username: null,
        currentUser: null,
      };
    case AuthActions.LOGIN_SUCCESS:
      const currentUser = action.entities.users[action.result.user];

      // Special case for missing token
      if (action.result.token) {
        setToken(action.result.token);

        return {
          ...state,
          loading: false,
          errorMessage: '',
          username: currentUser.username,
          currentUser: currentUser,
        };
      }

      return {
        ...state,
        loading: false,
        errorMessage: '',
        username: currentUser.username,
      }
    case AuthActions.LOGIN_ERROR:
      setToken(null);

      return {
        ...state,
        loading: false,
        errorMessage: action.error.errorMessage,
        currentUser: null,
      };

    // Logout
    case AuthActions.LOGOUT_REQUEST:
      return {
        ...state,
        loading: true,
        errorMessage: '',
      };
    case AuthActions.LOGOUT_SUCCESS:
      setToken(null);

      return {
        ...state,
        loading: false,
        errorMessage: '',
        currentUser: null,
      };
    case AuthActions.LOGOUT_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.error.errorMessage,
      };
    default:
      return state;
  }
}
